<script>
import { mapActions } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';
import MasterDataForm from './components/MasterDataForm';
import ClientHistory from './components/ClientHistory';
import Documents from './components/Documents';
import History from '../history';

export default {
  name: 'ClientDetails',
  components: {
    MasterDataForm,
    ClientHistory,
    History,
    Documents,
  },
  mixins: [mainViewTabMixin, snackbarMixin],
  data() {
    return {
      query: {},
      params: {},
      client: {},
      isLoading: false,
      isSaving: false,
      hasError: false,
      activeTab: 0,
    };
  },
  created() {
    const { query, params } = this.urlParser('/client/show/:id?', this.path);

    this.query = query;
    this.params = params;
    this.fetchData();
  },
  methods: {
    ...mapActions('clientDetails', ['fetchClient', 'saveClient']),
    fetchData() {
      this.isLoading = true;
      this.hasError = false;

      return this.fetchClient(this.params.id)
        .then(({ data }) => {
          this.client = data;
          this.updateTabTitle({ path: this.path, title: this.client.name });
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save() {
      this.isSaving = true;

      // console.log("this.client.questionaries 1", this.client.questionaries);
      // this.client.questionaries = this.client.questionaries.map((it) => {return {id: it.id}});
      // console.log("this.client.questionaries 2", this.client.questionaries);

      return this.saveClient(this.client)
        .then(() => {
          this.showSuccessMessage('Der Mandant wurde gespeichert.');
        })
        .catch(() => {
          this.showErrorMessage('Die Aktualisierung ist fehlgeschlagen.');
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    onQuestionaryChange(questionaries) {
      this.client.questionaries = questionaries;
    },
  },
};
</script>

<template>
  <div class="client-detail">
    <v-progress-linear v-if="isLoading" :indeterminate="true"/>

    <span
      v-else-if="hasError"
      class="js-error ma-3"
    >An error occurred while fetching client information</span>

    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="save" :loading="isSaving" icon slot="activator">
            <v-icon>save</v-icon>
          </v-btn>
          <span>Speichern</span>
        </v-tooltip>

      </v-toolbar>

      <v-tabs v-model="activeTab"
              height="35"
              slider-color="black"
              color="amber">
        <v-tab ripple>Stammdaten</v-tab>
        <v-tab ripple>Dokumente</v-tab>
        <v-tab ripple>Historie</v-tab>
        <v-tab ripple>Mandanten-Historie</v-tab>

        <v-tab-item>
          <master-data-form
            :client="client"
            @save="save"
            @questionaryChange="onQuestionaryChange"
          />
        </v-tab-item>

        <v-tab-item>
          <Documents
            :resource="'company'"
            :id="client.id"
            :allowed-file-types="['csv', 'doc', 'pdf', 'rtf', 'tex', 'txt', 'xlsx']"
          />
        </v-tab-item>

        <v-tab-item>
          <history :domain="'company'" :domain-id="client.id" path="/history" />
        </v-tab-item>

        <v-tab-item>
          <client-history :client-id="client.id" path="/client/history" />
        </v-tab-item>
      </v-tabs>

    </template>
  </div>
</template>

<style lang="scss">
.client-detail {
  &-title {
    margin-bottom: 10px;
  }

  &-actions {
    margin: 5px 0;

    .v-btn:first-child {
      border-radius: 5px 0 0 5px;
    }

    .v-btn:last-child {
      border-radius: 0 5px 5px 0;
    }

    .v-btn + .v-btn {
      border-left: 1px solid #fff !important;
    }

    .v-btn {
      margin: 0;
      width: 35px;
      height: 35px;
      border-radius: 0px;
    }
  }

  &-tab {
    padding-top: 10px;

    &-title {
      margin-bottom: 10px;
    }
  }

  &-common-list {
    margin-top: 5px;
    .v-btn {
      margin: 0px;
      width: 30px;
      height: 30px;
    }

    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:hover {
        .v-btn {
          opacity: 1;
        }
      }

      .v-btn {
        opacity: 0;
      }
    }
  }

  .v-tabs {
    &__items {
      padding-bottom: 30px;
    }
  }

  .submit-button {
    margin-top: 20px;
  }
}
</style>
